/* eslint-disable no-unused-vars */
import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import { PATH_AFTER_LOGIN } from '../config';
import LoadingScreen from '../components/LoadingScreen';
import ProtectedRoute from './ProtectedRoute';


const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: '/', element: <Login /> },
    { path: '/codemail', element: <CodeMail /> },
    { path: '/login/company', element: <CompanyLogin /> },
    { path: '/login/clinic', element: <ClinicLogin /> },
    { path: '/forget', element: <Register /> },
    { path: '/reset-passsword', element: <ResetPassword usertype={'company'} /> },
    { path: '/clinic-reset-passsword', element: <ResetPassword usertype={'clinic'} /> },
    {
      path: 'dashboard',
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <GeneralAnalytics /> },
        { path: 'product', element: <Product /> },
        { path: 'category', element: <Category /> },
        { path: 'editproduct/:id', element: <EditProduct /> },
        { path: 'addproduct', element: <AddProduct /> },
        { path: 'staff', element: <Staff /> },
        { path: 'editstaff/:id', element: <EditStaff /> },
        { path: 'addstaff', element: <AddStaff /> },
        { path: 'salary', element: <Salary /> },
        { path: 'editsalary/:id', element: <EditSalary /> },
        { path: 'addsalary', element: <AddSalary /> },
        { path: 'appointment', element: <Appointment /> },
        { path: 'editappointment/:id', element: <EditAppointment /> },
        { path: 'appointment_book', element: <AppointmentFinal /> },
        { path: 'addappointment', element: <AddAppointment /> },
        { path: 'walking', element: <Walking /> },
        { path: 'editwalking/:id', element: <EditWalking /> },
        { path: 'walking_book', element: <WalkingFinal /> },
        { path: 'addwalking', element: <AddWalking /> },
        { path: 'service', element: <Service /> },
        { path: 'attendance', element: <Attendance /> },
        { path: 'calculate_salary', element: <AddCalculate /> },
        { path: 'editservice/:id', element: <EditService /> },
        { path: 'addservice', element: <AddService /> },
        { path: 'editelement/:id', element: <EditElement /> },
        { path: 'viewelement/:id', element: <ViewElement /> },
        { path: 'companyProfile', element: <CompanyProfile /> },
        { path: 'addelement', element: <AddElement /> },
        { path: 'rarity', element: <Rarity /> },
        { path: 'editrarity/:id', element: <EditRarity /> },
        { path: 'addrarity', element: <AddRarity /> },
        { path: 'spell', element: <Spell /> },
        { path: 'editspell/:id', element: <EditSpell /> },
        { path: 'editadmin', element: <EditAdmin /> },
        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
          ],
        },
      ],
    },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const CompanyLogin = Loadable(lazy(() => import('../pages/auth/CompanyLogin')));
const ClinicLogin = Loadable(lazy(() => import('../pages/auth/ClinicLogin')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const CodeMail = Loadable(lazy(() => import('../pages/auth/CodeMail')));


// const Home = Loadable(lazy(() => import('../pages/dashboard/Home/Home')));
const Product = Loadable(lazy(() => import('../pages/dashboard/Product/Product')));
const EditProduct = Loadable(lazy(() => import('../pages/dashboard/Product/EditProduct')));
const AddProduct = Loadable(lazy(() => import('../pages/dashboard/Product/AddProduct')));
const Service = Loadable(lazy(() => import('../pages/dashboard/Services/Services')));
const EditService = Loadable(lazy(() => import('../pages/dashboard/Services/EditServices')));
const AddService = Loadable(lazy(() => import('../pages/dashboard/Services/AddServices')));
const Staff = Loadable(lazy(() => import('../pages/dashboard/Staff/Staff')));
const EditStaff = Loadable(lazy(() => import('../pages/dashboard/Staff/EditStaff')));
const AddStaff = Loadable(lazy(() => import('../pages/dashboard/Staff/AddStaff')));
const Salary = Loadable(lazy(() => import('../pages/dashboard/Salary/Salary')));
const EditSalary = Loadable(lazy(() => import('../pages/dashboard/Salary/EditSalary')));
const AddSalary = Loadable(lazy(() => import('../pages/dashboard/Salary/AddSalary')));
const Appointment = Loadable(lazy(() => import('../pages/dashboard/Appointment/Appointment')));
const EditAppointment = Loadable(lazy(() => import('../pages/dashboard/Appointment/EditAppointment')));
const AddAppointment = Loadable(lazy(() => import('../pages/dashboard/Appointment/AddAppointment')));
const AppointmentFinal = Loadable(lazy(() => import('../pages/dashboard/Appointment/AppointmentFinal')));
const Walking = Loadable(lazy(() => import('../pages/dashboard/Walking/Walking')));
const EditWalking = Loadable(lazy(() => import('../pages/dashboard/Walking/EditAppointment')));
const AddWalking = Loadable(lazy(() => import('../pages/dashboard/Walking/AddAppointment')));
const WalkingFinal = Loadable(lazy(() => import('../pages/dashboard/Walking/AppointmentFinal')));


const Category = Loadable(lazy(() => import('../pages/dashboard/Category')));
// const Element = Loadable(lazy(() => import('../pages/dashboard/Company/Element')));
const EditElement = Loadable(lazy(() => import('../pages/dashboard/Company/EditElement')));
const CompanyProfile = Loadable(lazy(() => import('../pages/dashboard/Company/CompanyProfile')));
const AddElement = Loadable(lazy(() => import('../pages/dashboard/Company/AddElement')));
const ViewElement = Loadable(lazy(() => import('../pages/dashboard/Company/ViewElement')));



const Rarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/Rarity')));
const EditRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/EditRarity')));
const AddRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/AddRarity')));
const EditAdmin = Loadable(lazy(() => import('../pages/dashboard/EditAdmin/EditAdmin')));

const Spell = Loadable(lazy(() => import('../pages/dashboard/Provider/Spell')));
const Attendance = Loadable(lazy(() => import('../pages/dashboard/Attendance/Attendance')));
const AddCalculate = Loadable(lazy(() => import('../pages/dashboard/CalculateSalary/AddCalculate')));
const EditSpell = Loadable(lazy(() => import('../pages/dashboard/Provider/EditSpell')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));


